class SegmentoController extends AbstractController
  @$inject = ['$injector', 'pathService', 'segmentoService']

  constructor: ($injector, pathService, @segmentoService) ->
    super($injector)

    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/segmento/'
    @modalSegmento = @openPopup(url + 'modal.html', 'segmentoModalController as ctrl', null, 'static')
    @loadingTracker = @promiseTracker()
    @list()

  list: () ->
    @loadingTracker.addPromise(
      @segmentoService.getList((data) =>
        @listOfSegmento = data
      )
    )

  abrirModel: (segmento) ->
    @modalSegmento({
      segmento: ->
        angular.copy segmento
    }, (result) =>
      @list())

  adicionar: () ->
    @abrirModel({})

  editar: (segmento) ->
    @abrirModel(segmento)

  remover: (segmento) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover o Grupos das tabelas PIS e COFINS <strong>#{segmento.nome}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @segmentoService.delete(segmento.id, =>
            Alert.success("Grupos das tabelas PIS e COFINS <strong>#{segmento.nome}</strong> removida com sucesso.")
            @list()
          )
        'Não': null
      })

angular.module("eficienciaFiscalModule").controller('segmentoController', SegmentoController)

class SegmentoModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'segmentoService', 'tabelaCodigoService', 'segmento']

  constructor: ($injector, @modalInstance, @segmentoService, tabelaService, segmento) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @listOfTabela = @lazyLoad('eficienciaFiscal->configuracao->tabelaService', (loaded)=>
      tabelaService.getList((data) =>
        loaded data
      )
    )

    @segmento = segmento

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @segmentoService.save(angular.copy(data), (result) =>
          if result.success
            @Alert.success("Grupos das tabelas PIS e COFINS <strong>#{data.nome}</strong> adicionada.", 'Sucesso')
            @modalInstance.close()
        )
      ) unless data.id
      @submitTracker.addPromise(
        @segmentoService.update(angular.copy(data), (result) =>
          @Alert.success("Grupos das tabelas PIS e COFINS <strong>#{data.nome}</strong> atualizado.", 'Sucesso')
          @modalInstance.close()
        )
      ) if data.id


angular.module("eficienciaFiscalModule").controller('segmentoModalController', SegmentoModalController)